import { atom } from "jotai";

const componentStackIdsAtom = atom<string[]>([]);

export default componentStackIdsAtom;
